"use client"

import { useId } from "react"
import {useUiControlLabels} from "@/components/i18n/ui-control-labels-context"
import { useField } from "formik"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"

type FormCheckboxProps = {
  name: string
  label: string
  disabled?: boolean
}

export function FormCheckbox({ name, label, disabled = false }: FormCheckboxProps) {
  const id = useId()
  const {fieldError} = useUiControlLabels()
  const [field, meta, helpers] = useField<boolean>(name)
  const error = meta.touched ? meta.error : undefined

  return (
    <div className="space-y-1">
      <div className="flex items-start gap-2">
        <Checkbox
          id={id}
          name={name}
          className="mt-0.5"
          checked={field.value}
          disabled={disabled}
          onCheckedChange={(checked) => {
            void helpers.setValue(checked === true)
            void helpers.setTouched(true, false)
          }}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        <Label htmlFor={id} className="text-sm font-normal leading-5">
          {label}
        </Label>
      </div>
      {error ? <p key={fieldError(error)} id={`${id}-error`} className="text-xs text-destructive">{fieldError(error)}</p> : null}
    </div>
  )
}
